import { putServiceForm } from 'features/salesOrder/services';
import { ServiceQuickEditContextValue } from '../context/ServiceQuickEditContext';

interface ExecuteServicePutParams {
	saleOrderId: string;
	serviceId: string;
	data: unknown;
	quickEdit?: ServiceQuickEditContextValue | null;
}

export const executeServicePut = async ({
	saleOrderId,
	serviceId,
	data,
	quickEdit,
}: ExecuteServicePutParams): Promise<boolean> => {
	if (quickEdit) {
		const confirmed = await quickEdit.requestConfirmation(data as Record<string, unknown>);
		if (!confirmed) {
			return false;
		}
	}

	await putServiceForm({
		saleOrderId,
		serviceId,
		data,
		agencyId: quickEdit?.agencyId,
	});

	if (quickEdit) {
		quickEdit.onSaveSuccess();
	}

	return true;
};
